import { put, call, takeLatest, select } from 'redux-saga/effects';

import getTime from 'date-fns/getTime';

import fbEmmiter from '../../../events/facebookEvents';
import { formatError } from '../../../libs';
import callMeAPI from '../../api/callMe';
import { Creators as AppCreators } from '../../reducers/app';
import { Creators, Types } from '../../reducers/callMe';
import { getUserInfo } from '../../utils/cookiesUser';
import { getState } from '../../utils/getState';
import getToken from '../../utils/getToken';

function* callMeRequest({ infos, day = {} }) {
  try {
    const { customer, app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const { id } = getUserInfo();

    const token = (yield select(getToken)) || infos.token;
    const customerId = customer.id || id;

    const body = {
      telefone: infos.tel,
      url: window.location.href,
    };

    let route = '';

    if (day && infos.scheduling) {
      const { year, numberMonth, day: numberDay } = day;
      const formatedNumberMonth = numberMonth - 1;
      const [hour, minute] = infos.hour.split(':');

      const timeStamp = getTime(new Date(year, formatedNumberMonth, numberDay, hour, minute));

      body.dataAgenda = timeStamp;
    }

    if (infos.ligar) {
      route = `/${customerId}/${infos.ligar}`;
      body.telefone = null;
    }

    const { result } = yield call(callMeAPI, body, route, token, siteId);

    yield put(Creators.callMeSuccess(result));

    fbEmmiter('Contact');
  } catch (error) {
    yield put(Creators.callMeFailed(formatError(error)));
    yield put(AppCreators.feedbackRequest({ message: formatError(error).message, open: true }));
  }
}

export default function* watch() {
  yield takeLatest(Types.CALL_ME_REQUEST, callMeRequest);
}
